import React, { useEffect, useMemo, useState, useRef, Fragment, useCallback } from 'react'
import { Option } from 'react-select/src/filters'
import styled from 'styled-components'
import { Option as OptionType } from 'shared/types'
import Checkbox from 'shared/components/Checkbox'
import SelectAutocomplete from 'shared/components/SelectAutocomplete'
import Box from 'shared/components/Box'

type SelectUserGroupProps = {
  options: OptionType[]
  selected: string[]
  node: string
  onChange: (key: string, value: any) => void
  removeOrAddToList: (checked: boolean, method: string) => any
}

function SelectUserGroup(props: SelectUserGroupProps) {
  const { options = [], selected = [], node = '', onChange, removeOrAddToList } = props
  const [isOpen, toggleSelector] = useState(false)
  const ref: any = useRef(null)

  useEffect(() => {
    function handleClickOutside(event: Event) {
      const options = document.querySelector(`.select-field__menu`)
      const target = event?.target as Node

      if (isOpen && !options?.contains(target)) toggleSelector(false)

      if (!isOpen && ref?.current?.contains(event?.target)) toggleSelector(true)
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('touchend', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchend', handleClickOutside)
    }
  }, [ref, isOpen])

  const OptionSelection = useCallback(
    (option: Option) => {
      const { data } = option
      return (
        <OptionUserGroupContainer
          onClick={() => {
            onChange(node, removeOrAddToList(Boolean(!selected.includes(data.value)), data?.value))
          }}
        >
          <Checkbox
            name={data?.label}
            id={data?.value}
            checked={Boolean(selected.includes(data.value))}
            label={data?.label}
          />
        </OptionUserGroupContainer>
      )
    },
    [node, onChange, removeOrAddToList],
  )

  const label = useMemo(() => {
    return selected.length > 4 ? `Selected ${selected.length}` : selected.join(', ')
  }, [selected])

  return (
    <SelectUserGroupContainer ref={ref}>
      <SelectAutocomplete
        isLoading={false}
        isSearchable={false}
        menuIsOpen={isOpen}
        value=""
        id="select-group"
        options={options}
        components={{
          Option: React.memo(OptionSelection),
        }}
        onChange={() => {}}
        onInputChange={() => {}}
        error=""
        label=""
        className=""
        placeholder=""
        menuPortalTarget={document.body}
      />
      <SelectLabelContainer>
        <SelectLabel>{label || 'Select...'}</SelectLabel>
      </SelectLabelContainer>
    </SelectUserGroupContainer>
  )
}

const SelectLabel = styled(Box)`
  font-size: 18px;
  color: #353535;
`
const SelectLabelContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 20px;
  width: auto;
  transform: translateY(-50%);
`

const SelectUserGroupContainer = styled(Box)`
  .select-field__menu-list {
    padding-bottom: 12px;
    padding-top: 12px;
  }

  .select-field__menu {
    z-index: 2;
  }
`

const OptionUserGroupContainer = styled(Box)`
  padding: 4px 16px;
  // border: 1px solid red;

  label {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
  }

  .md-selection-control-container {
    // border: 1px solid green;
    display: flex;
    align-items: center;
  }
`

export default SelectUserGroup
